import { ConfigProvider, CountryPhoneInput, CountryPhoneInputProps } from 'antd-country-phone-input';
import React from 'react';
import en from 'world_countries_lists/data/countries/en/world.json';

import 'antd-country-phone-input/dist/index.css';
import styled from 'styled-components';

export interface InputPropsInterface extends CountryPhoneInputProps {
  onChange: (value: any) => void;
}

const StyledCountryPhoneInput = styled(CountryPhoneInput)`
  .ant-input-group-addon {
    border-radius: 50px 0 0 50px;
  }
  .ant-input {
    border-radius: 0 50px 50px 0;
  }
`;

const PhoneInput = (props: InputPropsInterface) => {
  return (
    <ConfigProvider locale={en}>
      <StyledCountryPhoneInput inline className="rounded-full" onChange={props.onChange} {...props} />
    </ConfigProvider>
  );
};

export default PhoneInput;
